export var payproSuspendSubscription = function (input) {
    return {
        success: true
    };
};
